import { useState } from "react";
import { FolderTree, Table2 } from "lucide-react";
import WorkspaceFiles from "./WorkspaceFiles";
import WorkspaceSheets from "./WorkspaceSheets";

// apiBase: "/workspace" (client portal) or "/admin/workspace" (admin).
// clientEmail: only in admin mode — view/manage a specific client's workspace.
export default function Workspace({ apiBase = "/workspace", clientEmail = null }) {
  const [view, setView] = useState("files");
  const q = clientEmail ? `?client=${encodeURIComponent(clientEmail)}` : "";

  return (
    <div data-testid="workspace-board">
      <div className="inline-flex items-center gap-1 rounded-full bg-[#1e3d3a]/6 p-1 mb-5">
        <button data-testid="ws-tab-files" onClick={() => setView("files")}
          className={`inline-flex items-center gap-1.5 rounded-full px-4 py-1.5 text-sm font-medium transition-colors duration-200 ${view === "files" ? "bg-white text-[#1e3d3a] shadow-sm" : "text-[#1e3d3a]/55 hover:text-[#1e3d3a]"}`}>
          <FolderTree className="h-4 w-4" /> Files &amp; folders
        </button>
        <button data-testid="ws-tab-sheets" onClick={() => setView("sheets")}
          className={`inline-flex items-center gap-1.5 rounded-full px-4 py-1.5 text-sm font-medium transition-colors duration-200 ${view === "sheets" ? "bg-white text-[#1e3d3a] shadow-sm" : "text-[#1e3d3a]/55 hover:text-[#1e3d3a]"}`}>
          <Table2 className="h-4 w-4" /> Spreadsheets
        </button>
      </div>
      {view === "files" ? <WorkspaceFiles apiBase={apiBase} q={q} /> : <WorkspaceSheets apiBase={apiBase} q={q} />}
    </div>
  );
}
